<template lang="html">
  <div>
    <header class="uk-width uk-margin-remove uk-padding-remove">
      <h3 class="uk-flex-inline">Status wizyty</h3>
      <span v-if="status === 'zarejestrowana'" class="uk-label uk-label-primary" style="margin-top:-5px; margin-left:5px;">{{ status }}</span>
      <span v-else class="uk-label uk-label-warning" style="margin-top:-5px; margin-left:5px;">{{ status }}</span>

      <div v-if="status === 'zarejestrowana' && isBeforeVisit" class="float-right">
        <a v-if="platnoscOnline === 'enable'" v-bind:href="platnoscOnlineLink" target="_blank">
          <button class="uk-button uk-button-primary uk-button-small">Zapłać online</button>
        </a>
        <button uk-toggle="target: #change-visit-date-modal" class="uk-button uk-button-default uk-button-small">Zmień termin wizyty</button>
        <button uk-toggle="target: #cancel-visit-modal" class="uk-button uk-button-danger uk-button-small">Odwołaj wizytę</button>
      </div>
    </header>
    <div class="uk-flex uk-flex-wrap">
      <div id="visit-notifications" class="uk-width-1-2@m">

        <h4 style="margin-top:0px;">Szczegóły wizyty</h4>
        <strong>Powód wizyty:</strong> {{ reason }}<br />
        <strong>Lekarz:</strong> {{ doctor }}<br />
        <strong>Termin:</strong> {{ data | formatDate }}<br />
        <strong>Godzina:</strong> {{ data | formatTime }}<br />

        <strong>Lokalizacja wizyty:</strong> {{ adres1 }}, {{ adres2 }}<br />
        <strong v-show="information !== ''">Jak się przygotować do wizyty:</strong> {{ information }}<br />
        <strong>Rodzaj wizyty:</strong> {{ type === 'PLN' ? 'komercyjna' : (type === 'NFZ' ? 'refundowana NFZ' : 'bezpłatna') }}<br />
        <span v-if="type === 'PLN'"><strong>Cena:</strong> {{ cena }}</span><br />

        <strong v-if="position === '-1'"></strong>
        <strong v-else>Numer w kolejce:</strong>

        <span v-if="position === '-1'"></span>
        <span v-else>{{ position }}</span>
        <br />
        <hr class="uk-wdith">
      </div>
      <div id="visit-documents" class="uk-width-1-2@m uk-overflow-auto">
        <h4>Dokumentacja medyczna do pobrania</h4>
        <div v-if="documentsLoading">
          <div uk-spinner></div>
        </div>
        <div v-else>
          <div v-if="documents && documents !== ''">
            <table class="uk-table uk-table-middle uk-table-divider uk-table-hover">
              <thead>
                <tr>
                  <th class="uk-width-small">Status</th>
                  <th>Opis</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="document in documents">
                  <td>
                    <span style="background-color:#2ea278;" class="uk-label uk-label-success" v-if="document.IDportal === 1 || document.IDportal !== 4 && document.IDDokumenty !== 0">Gotowy do pobrania</span>
                    <span class="uk-label uk-label-primary" v-else-if="document.IDportal === 4 && document.IDDokumenty !== 0">Odbiór osobisty</span>
                    <span class="uk-label uk-label-warning" v-if="document.IDportal === 2 && document.IDDokumenty === 0">Wymaga zamówienia</span>
                    <span class="uk-label uk-label-warning" v-else-if="document.IDportal === 3 && document.IDDokumenty === 0">Wymaga zamówienia</span>
                    <span class="uk-label uk-label-warning" v-else-if="document.IDportal === 4 && document.IDDokumenty === 0">Wymaga zamówienia</span>
                  </td>
                  <td>{{ document.nazwa }}</td>
                  <td style="text-align: right; padding-right: 0px;">
                    <button @click="getDoc(document.IDDokumenty)" v-if="document.IDportal === 1 || document.IDportal !== 4 && document.IDDokumenty !== 0" class="uk-button uk-button-primary uk-button-small pull-right">Pobierz</button>
                    <button v-else-if="document.IDportal === 4 && document.IDDokumenty !== 0" class="uk-button uk-button-primary uk-button-small pull-right" disabled>Pobierz</button>
                    <button @click="orderDoc(document.IDKorSzablon)" v-if="document.IDportal === 2 && document.IDDokumenty === 0 || document.IDportal === 3 && document.IDDokumenty === 0 || document.IDportal === 4 && document.IDDokumenty === 0" class="uk-button uk-button-default uk-button-small pull-right">Zamów</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            Brak dokumentów do pobrania
          </div>
        </div>
      </div>
      <div v-show="ankietaPar === 1" id="visit-questionnaire" class="uk-width-2-2@m uk-margin-top">
        <h4 style="margin-top:0px !important;">Ankieta przed wizytą</h4>
        <strong v-if="ankietaPar !== 1">{{ ankietaTxt }}</strong>
        <div id="visit-questionnaire-box">
          <button v-if="ankietaPar === 1" @click="fillQuestionnaire" class="uk-button uk-button-primary">Wypełnij ankiete</button>
        </div>
      </div>
    </div>
    
    <!-- MODALS !-->
    <div id="change-visit-date-modal" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
          <h2 class="uk-modal-title">Zmiana terminu wizyty</h2>
          <p>Czy na pewno chcesz zmienić termin wizyty? Dotychczasowy termin wizyty zostanie anulowany.</p>
          <p class="uk-text-right">
              <button class="uk-button uk-button-default uk-modal-close" type="button">Nie</button>
              <button @click="changeVisit" class="uk-button uk-button-danger uk-modal-close" type="button">Tak</button>
          </p>
      </div>
    </div>
    <div id="cancel-visit-modal" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
          <h2 class="uk-modal-title">Odwołanie wizyty</h2>
          <p>Czy na pewno chcesz odwołać tą wizytę?</p>
          <p class="uk-text-right">
              <button class="uk-button uk-button-default uk-modal-close" type="button">Nie</button>
              <button @click="cancelVisit" class="uk-button uk-button-danger uk-modal-close" type="button">Tak</button>
          </p>
      </div>
    </div>
    <div id="exit-without-save-modal" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
          <h2 class="uk-modal-title">Wyjście z wizyty bez zapisu</h2>
          <p>Czy na pewno chcesz wyjść z widoku wizyty bez wcześniejczego zapisania zmian?</p>
          <p class="uk-text-right">
              <button @click="exitVisit(true)" class="uk-button uk-button-primary uk-modal-close" type="button">Zapisz zmiany i wyjdź</button>
              <button @click="exitVisit" class="uk-button uk-button-danger uk-modal-close" type="button">Tak</button>
          </p>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from 'uikit'
import $ from 'jquery'
import moment from 'moment'
export default {
  name: 'visit',
  data () {
    return {
      'platnoscOnline': '',
      'platnoscOnlineLink': '',
      'ankietaPar': '',
      'ankietaTxt': 'ANKIETA NIEDOSTĘPNA',
      'reason': '',
      'doctor': '',
      'data': '',
      'adres1': '',
      'adres2': '',
      'information': '',
      'type': '',
      'cena': '',
      'position': '',
      'status': '',
      'isBeforeVisit': '',
      documentsLoading: true,
      documents: [
        {
          'nazwa': '',
          'IDKorSzablon': '',
          'IDportal': '',
          'IDDokumenty': ''
        }
      ]
    }
  },
  mounted: function () {
    $('#sliderMain').css('display', 'none')
    $('#backbtn').css('display', 'block')
    $('#notifications').css('display', 'none')
    $('.session-info-wrap').css('width', '100%')
    this.documentsLoading = true
    if (this.$cookie.get('aut')) {
      var token = this.$cookie.get('aut')
      var visitId = this.$route.params.visitId
      var getDocumentsMetod = {'input': {'status': '', 'TOKEN': token, 'id': visitId}}
      this.$http.post('/api.php?url=getDocuments', getDocumentsMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
        var resp = response.data
        var documents = resp.d.data
        this.documents = documents
        this.documentsLoading = false
      }).catch((errors) => {
        JSON.stringify(errors)
        this.documents = null
        this.documentsLoading = false
      })
    }
    this.ankietaPar = this.$route.params.ankieta
    this.reason = this.$route.params.reason
    this.status = this.$route.params.status
    this.doctor = this.$route.params.doctor
    this.data = this.$route.params.data
    this.position = this.$route.params.position
    this.adres1 = this.$route.params.adres1
    this.adres2 = this.$route.params.adres2
    this.information = this.$route.params.information
    this.type = this.$route.params.type
    this.cena = this.$route.params.cena
    // check if visit datetime is before now
    var now = moment()
    var visitDate = moment(String(this.$route.params.data))
    this.isBeforeVisit = now.isBefore(visitDate)
    var getDomain = location.protocol + '//' + location.host
    this.$http.get(getDomain + '/config.php').then((response) => {
      var resp = response.data
      this.platnoscOnlineLink = resp.platnoscOnlineLink
      this.platnoscOnline = resp.platnoscOnline
    }).catch((errors) => {
      JSON.stringify(errors)
    })
  },
  methods: {
    fillQuestionnaire () {
      var visitId = this.$route.params.visitId
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut')
      }
      var getDomain = location.protocol + '//' + location.host
      $.ajax({
        url: getDomain + '/ankieta/parser.php',
        method: 'POST',
        contentType: 'application/json',
        success: function (data) {
          $('#visit-questionnaire-box').html(data)
          // asign all first radios
          $(':radio[value=0]').each(function () {
            $(this).attr('checked', true)
          })
          // send ankieta
          $('#sendQform').click(function () {
            // send ankieta to helper
            var formData = $('#qForm').serializeArray()
            $.ajax({
              url: getDomain + '/ankieta/helper.php',
              method: 'POST',
              data: formData,
              success: function (data) {
                // send ankieta to API
                var responseObj = JSON.parse(data)
                responseObj.input.TOKEN = token
                responseObj.input.id = visitId
                $.ajax({
                  url: '/api.php?url=setAnkieta',
                  method: 'POST',
                  data: JSON.stringify(responseObj),
                  contentType: 'application/json',
                  success: function (data) {
                    UIkit.modal.alert('Ankieta wysłana. Dziękujemy.')
                    $('#visit-questionnaire').html(' ')
                    this.$router.push('dashboard/main')
                  },
                  error: function (error) {
                    alert(JSON.stringify(error))
                  }
                })
              },
              error: function (error) {
                alert(JSON.stringify(error))
              }
            })
          })
        },
        error: function (error) {
          alert(JSON.stringify(error))
        }
      })
    },
    cancelVisit () {
      var visitId = this.$route.params.visitId
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut')
        var cancelVisitMetod = {'input': {'status': '', 'data': {'TOKEN': token, 'id': visitId, 'result': ''}}}
        this.$http.post('/api.php?url=cancelVisitREJ', cancelVisitMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
          UIkit.notification("<span uk-icon='icon: check'></span> Wizyta została odwołana.", 'success')
          this.$router.push('dashboard/main')
        }).catch((errors) => {
          JSON.stringify(errors)
        })
      }
    },
    changeVisit () {
      // cancelVisit
      var visitId = this.$route.params.visitId
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut')
        var cancelVisitMetod = {'input': {'status': '', 'data': {'TOKEN': token, 'id': visitId, 'result': ''}}}
        this.$http.post('/api.php?url=cancelVisitREJ', cancelVisitMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
          // changeVisit
          var getDomain = location.protocol + '//' + location.host
          this.$http.get(getDomain + '/config.php').then((response) => {
            var resp = response.data
            if (this.$cookie.get('aut')) {
              var token = this.$cookie.get('aut')
              document.location.href = resp.przenoszenieWizytyLink + token
            }
          }).catch((errors) => {
            JSON.stringify(errors)
          })
        }).catch((errors) => {
          JSON.stringify(errors)
        })
      }
    },
    orderDoc (docId) {
      var visitId = this.$route.params.visitId
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut')
        var orderDocumentMetod = {'input': {'status': '', 'data': {'TOKEN': token, 'IDKorSzablon': docId, 'IDRejestracja': visitId}}}
        this.$http.post('/api.php?url=orderDocument', orderDocumentMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
          var resp = response.data
          var ordered = resp.d.status
          if (JSON.stringify(ordered) === '"OK"') {
            UIkit.alert('Prośba o zamówienie dokumentu została wysłana.')
            // UIkit.notification("<span uk-icon='icon: check'></span>Prośba o zamówienie dokumentu została wysłana.", 'success')
          } else {
            UIkit.modal.alert('Dokument został juz zamówiony...')
          }
          // UIkit.notification("<span uk-icon='icon: check'></span>Prośba o zamówienie dokumentu została wysłana.", 'success')
        }).catch((errors) => {
          UIkit.modal.alert('Dokument został juz zamówiony.')
        })
      }
    },
    getDoc (docId) {
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut')
        var getDocumentMetod = {'input': {'status': '', 'TOKEN': token, 'id': docId}}
        this.$http.post('/api.php?url=getDocument', getDocumentMetod, {headers: {'Content-Type': 'application/json'}}).then((response) => {
          var odp = response.data
          var fileString = odp.d.data
          var doc = 'application/pdf;base64,' + fileString
          $('<a id="file_' + docId + '" style="display:none" href="data:' + doc + '" download="' + docId + 'file.pdf"></a>').appendTo('body')
          var elem = document.getElementById('file_' + docId)
          elem.click()
        }).catch((errors) => {
          if (JSON.stringify(errors.status) === '500') {
            UIkit.modal.alert('Serwer tymczasowo nie czynny')
          } else if (JSON.stringify(errors.status) === '404') {
            UIkit.modal.alert('Wystąpił problem z pobraniem pliku')
          } else {
            UIkit.modal.alert('Coś poszło nie tak... Kod: ' + errors.status)
          }
        })
      }
    },
    exitVisit (save) {
      save === true && this.saveVisit()
      this.$router.push('main')
    },
    saveVisit () {
      UIkit.notification("<span uk-icon='icon: check'></span> Zmiany zostały zapisane.", 'success')
    }
  }
}
</script>

<style lang="sass" scoped>

  .func-btn
    width: 40px
    padding: 0 10px

  .float-right

    @media screen and (min-width: 800px)
      float: right

    @media screen and (max-width: 800px)

      > button
        width: 100%
        height: 60px
        margin-bottom: 10px

  #visit-documents, #visit-notifications

    @media screen and (max-width: 960px)
      margin-top: 40px
</style>




// WEBPACK FOOTER //
// Visit.vue?27e673a8